import React from 'react';
import { appMethod as app } from '@utils/app';

import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import { GoodsShoppingCart } from 'src/common/goods-shopping-cart/GoodsShoppingCart';

import './ShoppingCart.less'

export default class ShoppingCart extends OfficialPage {
  state = {
    originGoodsList: [],
    cartType: -1,
    deliveryMethod: -1,
    editing: false,
    goodsCount: 0,
    goodsCountToPay: 0,
    priceToPay: 0.0,
    goodsList: [],
    unableData: [],
    isFromBack: false,
    selectAll: false,
    notBussinessTimeGoodId: [],
    showDeleteWindow: false,
    goodsList: [],
    currentSelectGoodsType: '',
    showFastGoods: true,
    showAddress: false, //是否显示地址
    storeStyle: {}
  }
  franchiseeId = ''
  isFromUserCenterEle = ''

  goodsShoppingCartRef = React.createRef();

  constructor(props) {
    super(props);
    document.title = '购物车';
    // WEBAPP: 处理后一个页面回来的回调
    if (app.getCurrentPage().callbackData) {
      this.currentPage = app.getCurrentPage();
    }
  }

  // WEBAPP: 处理后一个页面回来的回调
  handleCurrentPage() {
    if (!this.currentPage) {
      return;
    }
    if (this.currentPage.callbackData) {
      this.setData(this.currentPage.callbackData);
      this.currentPage.clearCallbackData();
    }
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    this.franchiseeId = options.franchisee || ''
    this.mode = options.fmode || ''
    this.isFromUserCenterEle = options.from || ''
    this.goodsScanCode = options.goodsScanCode
    let isFranchisee = false;
    let { goodsStoreConfig, hasFranchiseeList, hasFranchiseeChain } = app.globalData;
    if (goodsStoreConfig['cart_config'] && goodsStoreConfig['cart_config'].is_merge_shoppingcart == 1) { // 是否开启合并购物车
      if (hasFranchiseeList || hasFranchiseeChain) {
        isFranchisee = true;
      }
    }
    this.setData({
      franchiseeId: this.franchiseeId,
      isFranchisee
    })
    this.dataInitial()
  }

  componentDidMount() {
    if (this.isFromBack) {
      this.dataInitial()
      this.setData({
        selectAll: false,
        deliveryMethod: -1
      })
    } else {
      this.isFromBack = true
    }
    if (this.goodsScanCode) {
      this.scanShopping()
    }
  }

  dataInitial = () => {
    this.getShoppingCartData('first')
    this.getAppECStoreConfig()
    this.isShowAddress()
    this.handleCurrentPage()
  }
  getAppECStoreConfig = () => {
    app.getAppECStoreConfig(res => {
      this.setData({
        cartConfig: res.cart_config,
        storeStyle: res.color_config,
        tabExpress: res.express,
        tabIntraCity: res.intra_city,
        tabDelivery: res.is_self_delivery,
        tabDining: this.franchiseeId ? false : res.dining, //暂时不兼容子店(如果是子店 不显示堂食tab选项)
      })
    }, this.franchiseeId)
  }
  getShoppingCartData = frequency => {
    var _this = this,
      franchiseeId = this.franchiseeId,
      fromUserCenterEle = this.data.isFromUserCenterEle
    app.sendRequest({
      url: '/index.php?r=AppShop/cartList',
      data: {
        page: 1,
        page_size: 1000,
        sub_shop_app_id: franchiseeId,
        parent_shop_app_id: franchiseeId ? app.getAppId() : ''
      },
      success: function (res) {
        let originGoodsList = res.data || []
        let hasGoodsTypeObj = {}
        let cartType = 0
        let goodsList = []
        originGoodsList.map(item => {
          switch (item.goods_type) {
            case '0':
              hasGoodsTypeObj['hasGoods'] = true
              break
            case '2':
              hasGoodsTypeObj['hasWaimai'] = true
              break
            case '3':
              hasGoodsTypeObj['hasTostore'] = true
              break
          }
        })
        if (hasGoodsTypeObj['hasGoods']) {
          cartType = 0
          frequency == 'first' && _this.getCurrentLocation()
        } else if (hasGoodsTypeObj['hasWaimai']) {
          cartType = 2
        } else if (hasGoodsTypeObj['hasTostore']) {
          cartType = 3
        }
        originGoodsList.map(item => {
          if (item.goods_type == cartType) {
            goodsList.push(item)
          }
        })
        _this.setData({
          cartType: cartType,
          originGoodsList: originGoodsList,
          goodsList: goodsList,
          hasGoodsTypeObj: hasGoodsTypeObj,
          takeoutInfo: res.take_out_info,
          goodsCount: originGoodsList.length,
          unableData: res.unable_data
        })
        _this.clickSelectAll()
        _this.getTostoreNotBusinessTime()
        _this.recalculateCountPrice()
      }
    })
  }
  switchToEdit = () => {
    this.setData({
      editing: true
    })
  }
  editComplete = () => {
    this.setData({
      editing: false
    })
  }
  clickSelectGoods = e => {
    let index = e.currentTarget.dataset.index
    let goodsList = this.data.goodsList
    let selectAll = true
    let noSelectAll = true
    goodsList[index].selected = !goodsList[index].selected
    goodsList.map(item => {
      if (!item.selected) {
        selectAll = false
      } else {
        noSelectAll = false
      }
    })
    this.setData({
      goodsList: goodsList,
      selectAll: selectAll
    })
    this.recalculateCountPrice()
  }
  clickSelectAll = () => {
    let selectAll = this.data.selectAll
    let goodsList = this.data.goodsList
    goodsList.map(item => {
      item.selected = !selectAll
    })
    this.setData({
      selectAll: !selectAll,
      goodsList: goodsList
    })
    this.recalculateCountPrice()
  }
  recalculateCountPrice = () => {
    var goodsList = this.data.goodsList,
      totalCount = 0,
      price = 0
    goodsList.map(item => {
      if (item.selected) {
        totalCount += +item.num
        price += +item.price * +item.num
      }
    })
    this.setData({
      goodsCountToPay: totalCount,
      priceToPay: price.toFixed(2)
    })
  }
  getTostoreNotBusinessTime = (payIdArr, sucfn) => {
    var that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/precheckShoppingCart',
      method: 'post',
      data: {
        sub_shop_app_id: that.franchiseeId,
        cart_arr: payIdArr || '',
        parent_shop_app_id: that.franchiseeId ? app.getAppId() : ''
      },
      success: function (res) {
        sucfn && sucfn()
      },
      successStatusAbnormal: function (res) {
        if (res.status == 1) {
          var goodsId = res.expired_goods_arr || [],
            list = that.data.goodsList
          if (goodsId && goodsId.length) {
            for (var i = 0; i < goodsId.length; i++) {
              var id = goodsId[i].goods_id
              for (var j = list.length - 1; j >= 0; j--) {
                if (id == list[j].goods_id) {
                  list[j].selected = false
                }
              }
            }
            that.setData({
              selectAll: false,
              goodsList: list,
              notBussinessTimeGoodId: goodsId
            })
            that.recalculateCountPrice()
          }
        }
      }
    })
  }
  goToPay = e => {
    let payIdArr = []
    let franchiseeId = this.franchiseeId
    let cartIdArray = []
    let that = this
    let notBusinessTimeFlag = false
    let goodsList = this.data.goodsList
    let cartType = this.data.cartType
    goodsList.map(item => {
      if (item.selected) {
        cartIdArray.push(item.id)
        payIdArr.push({
          cart_id: item.id,
          goods_id: item.goods_id,
          model_id: item.model_id,
          model: item.model,
          num: item.num,
          goods_type: item.goods_type,
          is_seckill: item.is_seckill,
          seckill_start_state: item.seckill_start_state
            ? item.seckill_start_state
            : ''
        })
      }
    })
    if (!cartIdArray.length) {
      app.showModal({
        content: '请选择结算的商品'
      })
      return
    }
    that.getTostoreNotBusinessTime(payIdArr, function () {
      if (cartType == 0) {
        let tabExpress = that.data.tabExpress
        let tabDelivery = that.data.tabDelivery
        let tabIntraCity = that.data.tabIntraCity
        let addressId = that.data.selectSameJourneyId
        if (
          cartIdArray.length == 1 ||
          (tabExpress == 1 && tabDelivery != 1 && tabIntraCity != 1) ||
          (tabExpress != 1 && tabDelivery == 1 && tabIntraCity != 1) ||
          (tabExpress != 1 && tabDelivery != 1 && tabIntraCity == 1)
        ) {
          let pagePath =
            '/eCommerce/pages/previewGoodsOrder/previewGoodsOrder?cart_arr=' +
            encodeURIComponent(cartIdArray)
          franchiseeId && (pagePath += '&franchisee=' + franchiseeId)
          addressId && (pagePath += '&addressId=' + addressId)
          app.turnToPage(pagePath)
          return
        } else {
          that.showSettlement()
          return
        }
      } else if (cartType == 1) {
        var pagePath =
          '/eCommerce/pages/previewAppointmentOrder/previewAppointmentOrder?cart_arr=' +
          encodeURIComponent(cartIdArray)
        franchiseeId && (pagePath += '&franchisee=' + franchiseeId)
        app.turnToPage(pagePath)
      } else if (cartType == 3) {
        var pagePath =
          '/orderMeal/pages/previewOrderDetail/previewOrderDetail?cart_arr=' +
          encodeURIComponent(cartIdArray)
        franchiseeId && (pagePath += '&franchisee=' + franchiseeId)
        app.turnToPage(pagePath)
      } else if (cartType == 2) {
        if (+that.data.takeoutInfo.min_deliver_price > +that.data.priceToPay) {
          app.showModal({
            content:
              '没有达到起送价(' +
              that.data.takeoutInfo.min_deliver_price +
              '元)'
          })
          return
        }
        var pagePath =
          '/orderMeal/pages/previewTakeoutOrder/previewTakeoutOrder?cart_arr=' +
          encodeURIComponent(cartIdArray)
        franchiseeId && (pagePath += '&franchisee=' + franchiseeId)
        app.turnToPage(pagePath)
      }
    })
  }
  clickMinusButton = e => {
    let index = e.currentTarget.dataset.index,
      goodsType = e.currentTarget.dataset.type
    this.changeGoodsNum(index, 'minus')
  }
  clickPlusButton = e => {
    let index = e.currentTarget.dataset.index
    let goodsType = e.currentTarget.dataset.type
    this.changeGoodsNum(index, 'plus')
  }
  inputGoodsCount = e => {
    let goodsType = e.currentTarget.dataset.type
    let count = e.target.value
    let index = e.target.dataset.index
    if (count == '') {
      return
    }
    if (count == 0) {
      app.showModal({
        content: '请输入大于0的数字'
      })
      return
    }
    this.changeGoodsNum(index, 'number', count)
  }
  changeGoodsNum = (index, type, numberCount) => {
    let goodsList = this.data.goodsList
    let currentGoods = goodsList[index]
    let currentNum = +currentGoods.num,
      targetNum,
      _this = this,
      param
    if (type == 'plus') {
      targetNum = currentNum + 1
    } else if (type == 'minus') {
      targetNum = currentNum - 1
      if (targetNum <= 0) {
        this.setData({
          singelDeleteId: currentGoods.id
        })
        this.showDeleteWindow('singel')
        return
      }
    } else {
      targetNum = numberCount
    }
    if (+targetNum > +currentGoods.stock) {
      app.showModal({
        content: '库存不足'
      })
      return
    }
    if (currentGoods.form_data && currentGoods.form_data.seckill_activity_id) {
      param = {
        goods_id: currentGoods.goods_id,
        model_id: currentGoods.model_id || '',
        num: targetNum,
        sub_shop_app_id: this.franchiseeId,
        is_seckill: 1,
        form_data: {
          seckill_activity_id: currentGoods.form_data.seckill_activity_id,
          seckill_activity_time_id:
            currentGoods.form_data.seckill_activity_time_id
        }
      }
    } else {
      param = {
        goods_id: currentGoods.goods_id,
        model_id: currentGoods.model_id || '',
        num: targetNum,
        sub_shop_app_id: this.franchiseeId,
        is_seckill: currentGoods.is_seckill == 1 ? 1 : '',
        message_notice_type: 1
      }
    }
    app.sendRequest({
      url: '/index.php?r=AppShop/addCart',
      data: param,
      success: function (res) {
        currentGoods.num = targetNum
        _this.setData({
          goodsList: goodsList
        })
        _this.recalculateCountPrice()
      },
      successStatusAbnormal: function (res) {
        app.showModal({
          content: res.data
        })
      }
    })
  }
  goToHomepage = () => {
    let router = app.getHomepageRouter()
    app.turnToPage('/pages/' + router + '/' + router, true)
  }
  showDeleteWindow = type => {
    this.setData({
      deleteType: type,
      showDeleteWindow: true
    })
  }
  cancelDelete = () => {
    this.setData({
      showDeleteWindow: false
    })
  }
  sureDeleteGoods = e => {
    let _this = this
    let goodsList = this.data.goodsList
    let type = e.currentTarget.dataset.type
    let deleteArr = []
    if (type == 'singel') {
      deleteArr.push(this.data.singelDeleteId)
    } else {
      goodsList.map(item => {
        if (item.selected) {
          deleteArr.push(item.id)
        }
      })
    }
    if (deleteArr.length == 0) {
      _this.setData({
        showDeleteWindow: false,
        selectAll: false,
        currentSelectGoodsType: ''
      })
      app.showModal({
        content: '没有选择商品'
      })
      return
    }
    this.deleteGoods(deleteArr)
  }
  deleteGoods = deleteArr => {
    let _this = this
    let fromUserCenterEle = this.data.isFromUserCenterEle
    app.sendRequest({
      url: '/index.php?r=AppShop/deleteCart',
      method: 'post',
      data: {
        cart_id_arr: deleteArr,
        sub_shop_app_id: fromUserCenterEle ? '' : _this.franchiseeId
      },
      success: function (res) {
        _this.setData({
          showDeleteWindow: false,
          selectAll: false,
          currentSelectGoodsType: ''
        })
        _this.getShoppingCartData()
      }
    })
  }
  deleteUnableGoods = event => {
    let index = event.currentTarget.dataset.index
    let deleteId = this.data.unableData[index].id
    this.setData({
      singelDeleteId: deleteId
    })
    this.showDeleteWindow('singel')
  }
  changeCartType = e => {
    let { type, isFranchisee } = e.currentTarget.dataset;
    let { originGoodsList, deliveryMethod, cartType } = this.data;
    let appId = this.franchiseeId || app.getAppId();
    let goodsList = [];
    let setDataObj = {};
    if (type == cartType) { return }
    originGoodsList.map((item) => {
      item.selected = false;
      if (item.goods_type == type && item.app_id == appId) {
        goodsList.push(item);
      }
    })
    if (deliveryMethod != -1 && type == 0) {
      let filterGoodsList = [];
      goodsList.map((item) => {
        if (item.pick_up_type.indexOf(deliveryMethod) >= 0) {
          filterGoodsList.push(item);
        }
      })
      goodsList = filterGoodsList;
    }
    setDataObj['cartType'] = type;
    setDataObj['selectAll'] = false;
    setDataObj['goodsList'] = goodsList;

    if (isFranchisee) { // 多商家多店
      let { shopsList } = this.data;
      shopsList.forEach(shop => {
        shop.selected = false;
        shop['cartList'].forEach((cart) => cart.selected = false);
      });
      setDataObj['shopsList'] = shopsList;
    }
    this.setData(setDataObj);
    this.recalculateCountPrice();
  }
  goCommodityDetail = event => {
    let franchiseeParam = this.franchiseeId
      ? '&franchisee=' + this.franchiseeId
      : ''
    app.turnToPage(
      '/pages/goodsDetail/goodsDetail?detail=' +
      event.currentTarget.dataset.id +
      franchiseeParam
    )
  }
  stopPropagation = () => { }
  filterDeliveryMethod = e => {
    let originGoodsList = this.data.originGoodsList
    let goodsList = []
    let type = e.currentTarget.dataset.type
    originGoodsList.map(item => {
      if (item.goods_type == 0) {
        goodsList.push(item)
      }
    })
    if (!goodsList) {
      return
    }
    if (type != -1) {
      let filterGoodsList = []
      goodsList.map(item => {
        if (item.pick_up_type.indexOf(type) >= 0) {
          filterGoodsList.push(item)
        }
      })
      goodsList = filterGoodsList
    }
    this.setData({
      goodsList: goodsList,
      deliveryMethod: type
    })
    this.recalculateCountPrice()
  }
  getCurrentLocation = () => {
    let _this = this
    app.getLocation({
      success(res) {
        const latitude = res.latitude
        const longitude = res.longitude
        app.sendRequest({
          url: '/index.php?r=Map/getAreaInfoByLatAndLng',
          method: 'post',
          data: {
            latitude: latitude,
            longitude: longitude
          },
          success: function (res) {
            _this.setData({
              currentLocationData: res.data
            })
          }
        })
      },
      fail: function (res) { }
    })
  }
  selectGoodsSameJourney = () => {
    let selectSameJourney = this.data.selectSameJourney
    this.closeSettlement()
    app.turnToPage(
      '/eCommerce/pages/goodsSameJourney/goodsSameJourney?sameJourneyId=' +
      (selectSameJourney ? selectSameJourney.id : '') +
      '&franchiseeId=' +
      this.franchiseeId
    )
  }
  showSettlement = () => {
    let _this = this
    let goodsList = this.data.goodsList
    let goodsIds = []
    let expressData = {
      goodsIds: [],
      totalPrice: 0
    }
    let sameCityData = {
      goodsIds: [],
      totalPrice: 0
    }
    let selfLiftData = {
      goodsIds: [],
      totalPrice: 0
    }
    let currentLocationData = this.data.currentLocationData
    let selectSameJourney = this.data.selectSameJourney
    let lat = selectSameJourney
      ? selectSameJourney.latitude
      : currentLocationData.location.lat
    let lng = selectSameJourney
      ? selectSameJourney.longitude
      : currentLocationData.location.lng
    let regionId = selectSameJourney
      ? selectSameJourney.address_info.district.id
      : currentLocationData.region_id
    goodsList.map(item => {
      if (item.selected) {
        if (item.pick_up_type.indexOf('1') >= 0) {
          expressData.goodsIds.push(item.id)
          expressData.totalPrice += +item.price
        }
        if (item.pick_up_type.indexOf('2') >= 0) {
          sameCityData.goodsIds.push(item.id)
          sameCityData.totalPrice += +item.price
        }
        if (item.pick_up_type.indexOf('3') >= 0) {
          selfLiftData.goodsIds.push(item.id)
          selfLiftData.totalPrice += +item.price
        }
        goodsIds.push(+item.id)
      }
    })
    if (!goodsIds.length) {
      app.showModal({
        content: '请选择商品'
      })
      return
    }
    app.sendRequest({
      url: '/index.php?r=AppEcommerce/getCanUsePickUpTypeAtCart',
      method: 'post',
      data: {
        latitude: lat,
        longitude: lng,
        region_id: regionId,
        cart_id_arr: goodsIds,
        sub_shop_app_id: _this.franchiseeId
      },
      success: function (res) {
        let data = res.data
        let cartIdArray
        if (
          data.hasOwnProperty(1) &&
          !data.hasOwnProperty(2) &&
          !data.hasOwnProperty(3) &&
          !data.hasOwnProperty(4)
        ) {
          cartIdArray = data[1].cart_list
        }
        if (
          !data.hasOwnProperty(1) &&
          data.hasOwnProperty(2) &&
          !data.hasOwnProperty(3) &&
          !data.hasOwnProperty(4)
        ) {
          cartIdArray = data[2].cart_list
        }
        if (
          !data.hasOwnProperty(1) &&
          !data.hasOwnProperty(2) &&
          data.hasOwnProperty(3) &&
          !data.hasOwnProperty(4)
        ) {
          cartIdArray = data[3].cart_list
        }
        if (
          !data.hasOwnProperty(1) &&
          !data.hasOwnProperty(2) &&
          !data.hasOwnProperty(3) &&
          data.hasOwnProperty(4)
        ) {
          cartIdArray = data[4].cart_list
        }
        if (cartIdArray) {
          let franchiseeId = _this.franchiseeId
          let addressId = this.data.selectSameJourneyId
          let pagePath =
            '/eCommerce/pages/previewGoodsOrder/previewGoodsOrder?cart_arr=' +
            encodeURIComponent(cartIdArray)
          franchiseeId && (pagePath += '&franchisee=' + franchiseeId)
          addressId && (pagePath += '&addressId=' + addressId)
          app.turnToPage(pagePath)
          return
        }
        _this.setData({
          canUsePickUpType: data,
          intraCityData: (data[2] && data[2].intra_city_data) || '',
          diningData: data[4] && data[4].dining_data || '',
          showSettlementMask: true
        })
      }
    })
  }
  closeSettlement = () => {
    this.setData({
      showSettlementMask: false
    })
  }
  goodsPay = e => {
    var franchiseeId = this.franchiseeId,
      cartIdArray = [],
      type = e.currentTarget.dataset.type,
      cartId = e.currentTarget.dataset.cartId,
      addressId = this.data.selectSameJourneyId
    cartIdArray = cartId
    var pagePath =
      '/eCommerce/pages/previewGoodsOrder/previewGoodsOrder?type=' +
      type +
      '&cart_arr=' +
      encodeURIComponent(cartIdArray)
    franchiseeId && (pagePath += '&franchisee=' + franchiseeId)
    addressId && (pagePath += '&addressId=' + addressId)
    this.closeSettlement()
    app.turnToPage(pagePath)
  }
  scanShopping = () => {
    app.showToast({title: '暂不支持扫码购功能'});
    return;

    let _this = this;

    app.scanCode({
      success: function (res) {
        app.sendRequest({
          url: '/index.php?r=AppShop/addCartByGoodsCode',
          data: {
            code: res.result,
            sub_shop_app_id: _this.franchiseeId
          },
          success: function (res) {
            _this.afterSelectedGoods()
          }
        })
      },
      fail: function (res) {
        app.showModal({
          content: '未检索到商品'
        })
      }
    })
  }
  afterSelectedGoods = () => {
    this.setData({
      selectAll: false
    })
    this.getShoppingCartData()
  }
  scanMove = event => {
    let y = event.changedTouches[0].clientY
    let width = window.innerWidth;
    let maxHeight = window.innerHeight - (208 / 750) * width
    y = y < 0 ? 0 : y > maxHeight ? maxHeight : y
    this.setData({
      widowTop: y
    })
  }
  addFavoriteGoods = e => {
    let goodsList = this.data.goodsList
    let goodsIds = []
    let _this = this
    goodsList.map(item => {
      if (item.selected) {
        goodsIds.push(+item.goods_id)
      }
    })
    if (!goodsIds.length) {
      app.showModal({
        content: '未选中商品'
      })
      return;
    }
    app.sendRequest({
      url: '/index.php?r=AppShop/addFavoriteGoods',
      method: 'post',
      data: {
        form_id: e.detail.formId,
        goods_ids: goodsIds,
        sub_shop_app_id: _this.franchiseeId
      },
      success: function (res) {
        app.showModal({
          content: '成功加入收藏夹'
        })
      }
    })
  }
  showFastGoods = () => {
    let _this = this
    this.setData({
      showFastGoods: !_this.data.showFastGoods
    })
  }
  selectGoodsDetail = event => {
    let newData = {
      goodsId: event.currentTarget.dataset.goodsId,
      franchisee: this.franchiseeId
    }
    this.goodsShoppingCartRef.current.show({afterSelectedGoods: this.afterSelectedGoods});
    this.goodsShoppingCartRef.current.showDialog(newData);
  }
  isShowAddress = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppEcommerce/getSwitchBySwitchName',
      method: 'post',
      data: {
        switch_name: 'intra_city_address_position'
      },
      success: function (res) {
        if (!res.status) {
          that.setData({
            showAddress: res.data == 1 ? true : false
          })
        }
      }
    })
  }

  render() {
    const {
      showGetUserInfo,
      originGoodsList,
      storeStyle,
      cartType,
      hasGoodsTypeObj,
      editing,
      selectSameJourney,
      currentLocationData,
      showAddress,
      deliveryMethod,
      tabExpress,
      tabDelivery,
      tabIntraCity,
      tabDining,
      diningData,
      goodsList,
      item,
      unableData,
      cartConfig,
      showFastGoods,
      selectAll,
      goodsCountToPay,
      priceToPay,
      franchiseeId,
      widowTop,
      deleteType,
      showDeleteWindow,
      canUsePickUpType,
      intraCityData,
      showSettlementMask
    } = this.state

    return (
      <React.Fragment>
        <div className="official-page shopping-cart">
          <TopNav title="购物车"/>
          <div style={convertLineStyleData(originGoodsList.length ? 'padding-bottom: 100rpx' : '')}>
            {!!originGoodsList.length && (
              <React.Fragment>
                <div className="cart-header">
                  <div
                    className="cart-type-box"
                    style={convertLineStyleData(
                      'color:' +
                      storeStyle.theme +
                      ';border-color:' +
                      storeStyle.theme
                    )}
                  >
                    {hasGoodsTypeObj['hasGoods'] && (
                      <span
                        style={convertLineStyleData(
                          'border-color:' +
                          storeStyle.theme +
                          (cartType == 0 ? ';background:' + storeStyle.theme : '')
                        )}
                        className={cartType == 0 ? 'selected' : ''}
                        onClick={this.changeCartType}
                        data-type="0"
                      >
                        基础
                      </span>
                    )}
                    {hasGoodsTypeObj['hasTostore'] && (
                      <span
                        style={convertLineStyleData(
                          'border-color:' +
                          storeStyle.theme +
                          (cartType == 3 ? ';background:' + storeStyle.theme : '')
                        )}
                        className={cartType == 3 ? 'selected' : ''}
                        onClick={this.changeCartType}
                        data-type="3"
                      >
                        到店
                      </span>
                    )}
                    {hasGoodsTypeObj['hasWaimai'] && (
                      <span
                        style={convertLineStyleData(
                          cartType == 2 ? 'background:' + storeStyle.theme : ''
                        )}
                        className={cartType == 2 ? 'selected' : ''}
                        onClick={this.changeCartType}
                        data-type="2"
                      >
                        外卖
                      </span>
                    )}
                  </div>
                  {editing && (
                    <div
                      style={convertLineStyleData('color:' + (storeStyle.theme || '#ff7100'))}
                      className="pull-right ico-moon icon-success-tip shopping-cart-editor border-left"
                      onClick={this.editComplete}
                    ></div>
                  )}
                  {!editing && (
                    <div
                      className="pull-right ico-moon icon-shopping-cart-set shopping-cart-editor border-left"
                      onClick={this.switchToEdit}
                    ></div>
                  )}
                </div>
                {cartType == 0 && (
                  <React.Fragment>
                    {showAddress && (
                      <div
                        className="goods-location-box"
                        onClick={this.selectGoodsSameJourney}
                      >
                        <span className="ico-moon icon-goods-location"></span>
                        <span className="address-box">
                          {selectSameJourney
                            ? selectSameJourney.address_info.province.text +
                            selectSameJourney.address_info.city.text +
                            selectSameJourney.address_info.district.text +
                            selectSameJourney.detail_address
                            : (currentLocationData && currentLocationData.formatted_addresses && currentLocationData.formatted_addresses.recommend) ||
                            '暂无地址,请点击选择地址'}
                        </span>
                        <span className="trangel"></span>
                      </div>
                    )}
                    <div className="goods-delivery-method">
                      <span
                        onClick={this.filterDeliveryMethod}
                        style={convertLineStyleData(
                          deliveryMethod == -1 ? 'color:' + storeStyle.theme : ''
                        )}
                        data-type="-1"
                        className={deliveryMethod == -1 ? 'selected' : ''}
                      >
                        全部
                        <span
                          className="bottom-line"
                          style={convertLineStyleData('background:' + storeStyle.theme)}
                        ></span>
                      </span>
                      {tabExpress == 1 && (
                        <span
                          onClick={this.filterDeliveryMethod}
                          style={convertLineStyleData(
                            deliveryMethod == 1 ? 'color:' + storeStyle.theme : ''
                          )}
                          data-type="1"
                          className={deliveryMethod == 1 ? 'selected' : ''}
                        >
                          快递
                          <span
                            className="bottom-line"
                            style={convertLineStyleData('background:' + storeStyle.theme)}
                          ></span>
                        </span>
                      )}
                      {tabDelivery == 1 && (
                        <span
                          onClick={this.filterDeliveryMethod}
                          style={convertLineStyleData(
                            deliveryMethod == 3 ? 'color:' + storeStyle.theme : ''
                          )}
                          data-type="3"
                          className={deliveryMethod == 3 ? 'selected' : ''}
                        >
                          自提
                          <span
                            className="bottom-line"
                            style={convertLineStyleData('background:' + storeStyle.theme)}
                          ></span>
                        </span>
                      )}
                      {tabIntraCity == 1 && (
                        <span
                          onClick={this.filterDeliveryMethod}
                          style={convertLineStyleData(
                            deliveryMethod == 2 ? 'color:' + storeStyle.theme : ''
                          )}
                          data-type="2"
                          className={deliveryMethod == 2 ? 'selected' : ''}
                        >
                          同城
                          <span
                            className="bottom-line"
                            style={convertLineStyleData('background:' + storeStyle.theme)}
                          ></span>
                        </span>
                      )}
                      {tabDining == 1 && (
                        <span
                          onClick={this.filterDeliveryMethod}
                          style={convertLineStyleData(
                            deliveryMethod == 4
                              ? 'color:' + storeStyle.theme
                              : ''
                          )}
                          data-type="4"
                          className={deliveryMethod == 4 ? 'selected' : ''}
                        >
                          点餐
                          <span
                            className="bottom-line"
                            style={convertLineStyleData('background:' + storeStyle.theme)}
                          ></span>
                        </span>
                      )}
                    </div>
                  </React.Fragment>
                )}
              </React.Fragment>
            )}
            {originGoodsList.length === 0 && (
              <div className="shoppingCart-null">
                <img src="http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/shopping-cart-null.png" />
                <div className="shoppingCart-null-label">购物车空空哒</div>
                <div
                  className="go-home-page"
                  style={convertLineStyleData('background:' + storeStyle.theme)}
                  onClick={this.goToHomepage}
                >
                  去逛逛
                </div>
              </div>
            )}
            <div className="shoppingCart-wrap page" id="shoppingCart">
              <div className="shoppingCart-goods-list">
                {goodsList.map((goods, index) => {
                  return (
                    <div key={goods.id}>
                      <label
                        data-index={index}
                        style={convertLineStyleData(goods.selected ? 'color:' + storeStyle.theme : '')}
                        className={
                          'shoppingCart-check-box ' +
                          (goods.selected
                            ? 'checked ico-moon icon-success-tip'
                            : '')
                        }
                        data-type={goods.type}
                        onClick={this.clickSelectGoods}
                      ></label>
                      <div className="shoppingCart-goods-content">
                        <div className="shoppingCart-goods-cover">
                          <img src={goods.cover} />
                        </div>
                        <div className="goods-content-box">
                          <div className="shoppingCart-goods-title">
                            {goods.is_group_buy == 1 && (
                              <span className="is-seckill">拼团</span>
                            )}
                            {goods.is_seckill == 1 && (
                              <span className="is-seckill">秒杀</span>
                            )}
                            {goods.title}
                          </div>
                          {goods.model_value_str && (
                            <div className="ellipsis shoppingCart-goods-model">
                              {goods.model_value_str}
                            </div>
                          )}
                          <div className="shoppingCart-price-box">
                            {(goods.integral != '2' ||
                              (goods.price != 0 && goods.price != '0.00')) && (
                                <span
                                  className="real-price"
                                  style={convertLineStyleData('color:' + storeStyle.theme)}
                                >
                                  {'¥' + goods.price}
                                </span>
                              )}
                            {goods.integral == '2' &&
                              (goods.price != 0 || goods.price != '0.00') && (
                                <span
                                  className="real-price"
                                  style={convertLineStyleData('color:' + storeStyle.theme)}
                                >
                                  +
                                </span>
                              )}
                            {goods.integral == '2' && (
                              <span
                                className="real-price"
                                style={convertLineStyleData('color:' + storeStyle.theme)}
                              >
                                {goods.max_can_use_integral + '积分'}
                              </span>
                            )}
                            <div
                              className="goods-number-box pull-right"
                              onClick={this.stopPropagation}
                            >
                              <div
                                className="goods-num-mius"
                                onClick={this.clickMinusButton}
                                data-type={goods.type}
                                data-index={index}
                              >
                                -
                              </div>
                              <input
                                type="number"
                                className="goods-num-box"
                                value={goods.num}
                                data-type={goods.type}
                                data-index={index}
                                onChange={this.inputGoodsCount}
                              />
                              <div
                                className="goods-num-plus"
                                style={convertLineStyleData('color:' + storeStyle.theme)}
                                data-type={goods.type}
                                onClick={this.clickPlusButton}
                                data-index={index}
                              >
                                +
                              </div>
                            </div>
                            {goods.cart_vip_goods == 1 && <span className="vip-logo">会员价</span>}
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })}
              </div>
              {!!unableData.length && (
                <div className="shoppingCart-goods-list unable-goods-list">
                  <div className="fast-goods-header">失效商品</div>
                  {unableData.map((goods, index) => {
                    return (
                      <div key={goods.id}>
                        <div className="shoppingCart-goods-content">
                          <div className="shoppingCart-goods-cover">
                            <img src={goods.cover} />
                          </div>
                          <div className="goods-content-box">
                            <div className="shoppingCart-goods-title">
                              {goods.is_seckill == 1 && (
                                <span className="is-seckill">秒杀</span>
                              )}
                              {goods.title}
                            </div>
                            {goods.model_value_str && (
                              <div className="ellipsis shoppingCart-goods-model">
                                {goods.model_value_str}
                              </div>
                            )}
                            <div className="shoppingCart-price-box">
                              <span>已失效，去看看其它商品吧</span>
                              <span
                                className="ico-moon icon-shopping-cart-delete pull-right"
                                onClick={this.deleteUnableGoods}
                                data-index={index}
                              ></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  })}
                </div>
              )}
            </div>
            {cartConfig && cartConfig.convenient_shopping && cartConfig.convenient_shopping.goods && cartType == 0 && (
              <div className="fast-goods">
                <div className="fast-goods-header" onClick={this.showFastGoods}>
                  {cartConfig.convenient_shopping.name}
                  <span
                    className={
                      'pull-right ico-moon icon-rightarrow ' +
                      (showFastGoods ? 'show' : '')
                    }
                  ></span>
                </div>
                {showFastGoods && (
                  <React.Fragment>
                    {cartConfig.convenient_shopping.goods.map((goods, index) => {
                      return (
                        <div key={goods.id}>
                          <div className="shoppingCart-goods-content">
                            <div className="shoppingCart-goods-cover">
                              <img src={goods.cover} />
                            </div>
                            <div className="goods-content-box">
                              <div className="shoppingCart-goods-title">
                                {goods.is_seckill == 1 && (
                                  <span className="is-seckill">秒杀</span>
                                )}
                                {goods.title}
                              </div>
                              {goods.model_value_str && (
                                <div className="ellipsis shoppingCart-goods-model">
                                  {goods.model_value_str}
                                </div>
                              )}
                              <div className="shoppingCart-price-box">
                                <span
                                  className="real-price"
                                  style={convertLineStyleData('color:' + storeStyle.theme)}
                                >
                                  {'¥' + goods.price}
                                </span>
                                {goods.is_seckill == 1 && (
                                  <span className="seckill-price">
                                    {'¥' + goods.original_price}
                                  </span>
                                )}
                                <div
                                  onClick={this.selectGoodsDetail}
                                  data-goods-id={goods.id}
                                  className="pull-right addShoppingcart ico-moon icon-addshoppingcart3"
                                ></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    })}
                  </React.Fragment>
                )}
              </div>
            )}
          </div>
          {!!originGoodsList.length && (
            <div className="shoppingCart-bottom-nav" style={{
              bottom: app.isTabBarPage() ? '48px' : ''
            }}>
              <label
                style={convertLineStyleData(selectAll ? 'color:' + storeStyle.theme : '')}
                className={
                  'shoppingCart-check-box ' +
                  (selectAll ? 'checked ico-moon icon-success-tip' : '')
                }
                onClick={this.clickSelectAll}
              ></label>
              <span
                className="select-all"
                style={convertLineStyleData(selectAll ? 'color:' + storeStyle.theme : '')}
              >
                全选
              </span>
              {!editing ? (
                <React.Fragment>
                  <button
                    onClick={this.goToPay}
                    type="button"
                    data-type={deliveryMethod}
                    style={convertLineStyleData('background:' + storeStyle.theme)}
                    className="pull-right shoppingCart-goto-pay"
                  >
                    {'结算(' + goodsCountToPay + ')'}
                  </button>
                  <div className="pull-right total-price-box">
                    <div
                      className="shoppingCart-all-price"
                      style={convertLineStyleData('color:' + storeStyle.theme)}
                    >
                      {'¥' + priceToPay}
                    </div>
                    <div className="no-contain-freight">不含运费</div>
                  </div>
                </React.Fragment>
              ) : (
                  <React.Fragment>
                    <span
                      className="pull-right mutiple-delete-btn"
                      onClick={this.showDeleteWindow}
                    >
                      删除
                  </span>
                    {cartType == 0 && !franchiseeId && (
                      <button
                        type="button"
                        onClick={this.addFavoriteGoods}
                        className="pull-right add-to-favorites"
                      >
                        移入收藏夹
                      </button>
                    )}
                  </React.Fragment>
                )}
            </div>
          )}
          {cartConfig && cartConfig.shopping_by_scanning_code == 1 && (
            <div
              className="scan-it"
              onClick={this.scanShopping}
              onTouchMove={this.scanMove}
              style={convertLineStyleData(
                'box-shadow: 0 0 6rpx' +
                storeStyle.theme +
                ';background:' +
                storeStyle.theme +
                ';top:' +
                widowTop +
                'px;'
              )}
            >
              <span className="ico-moon icon-shopping-scan"></span>
              <div className="scan-it-word">扫码购</div>
            </div>
          )}
          {showDeleteWindow && (
            <div className="delete-tip-window">
              <div className="delete-box">
                <div className="delete-tip">确定要删除所选商品吗？</div>
                <div className="delete-btn-box">
                  <span onClick={this.cancelDelete}>取消</span>
                  {deleteType == 'singel' ? (
                    <span
                      style={convertLineStyleData('color:' + storeStyle.theme)}
                      data-type="singel"
                      className="sure-delete"
                      onClick={this.sureDeleteGoods}
                    >
                      确定
                    </span>
                  ) : (
                      <span
                        className="sure-delete"
                        style={convertLineStyleData('color:' + storeStyle.theme)}
                        data-type="mutiple"
                        onClick={this.sureDeleteGoods}
                      >
                        确定
                    </span>
                    )}
                </div>
              </div>
            </div>
          )}
          {showSettlementMask && (
            <div className="settlement-mask" onTouchMove={this.stopPropagation}>
              <div className="settlement-box">
                <div className="settlement-title">请选择取货方式</div>
                {!!(canUsePickUpType[1] && canUsePickUpType[1].cart_list.length) && (
                  <div className="settlement-type">
                    <div className="settlement-type-content">
                      <div>
                        <span
                          className="settlement-type-title"
                          style={convertLineStyleData('color:' + storeStyle.theme)}
                        >
                          <span className="ico-moon icon-goods-express-model"></span>
                          快递配送
                        </span>
                        <span className="settlement-type-express">
                          {'配送费' +
                            (canUsePickUpType[1] && canUsePickUpType[1].express_data && canUsePickUpType[1].express_data.express_fee || 0) +
                            '元'}
                        </span>
                      </div>
                      <div className="settlement-type-count">
                        {'共' +
                          canUsePickUpType[1].goods_num +
                          '件，合计：¥' +
                          canUsePickUpType[1].goods_price}
                      </div>
                    </div>
                    <div className="settlement-btn-box">
                      <div
                        data-type="1"
                        data-cart-id={canUsePickUpType[1].cart_list}
                        className="settlement-btn"
                        style={convertLineStyleData(
                          'color:' +
                          storeStyle.theme +
                          ';border-color:' +
                          storeStyle.theme
                        )}
                        onClick={this.goodsPay}
                      >
                        选择
                      </div>
                    </div>
                  </div>
                )}
                {!!(canUsePickUpType[3] && canUsePickUpType[3].cart_list.length) && (
                  <div className="settlement-type">
                    <div className="settlement-type-content">
                      <div>
                        <span
                          className="settlement-type-title"
                          style={convertLineStyleData('color:' + storeStyle.theme)}
                        >
                          <span className="ico-moon icon-goods-delivery-model"></span>
                          上门自提
                        </span>
                        {/* <span className="settlement-type-express">配送费0元</span> */}
                      </div>
                      <div className="settlement-type-count">
                        {'共' +
                          canUsePickUpType[3].goods_num +
                          '件，合计：¥' +
                          canUsePickUpType[3].goods_price}
                      </div>
                    </div>
                    <div className="settlement-btn-box">
                      <div
                        data-type="3"
                        data-cart-id={canUsePickUpType[3].cart_list}
                        className="settlement-btn"
                        style={convertLineStyleData(
                          'color:' +
                          storeStyle.theme +
                          ';border-color:' +
                          storeStyle.theme
                        )}
                        onClick={this.goodsPay}
                      >
                        选择
                      </div>
                    </div>
                  </div>
                )}
                {!!(canUsePickUpType[2] && canUsePickUpType[2].cart_list.length) && (
                  <div className="settlement-type">
                    <div
                      className={
                        'settlement-type-content ' +
                        (intraCityData.is_enough_price != 1 ||
                          intraCityData.in_distance != 1 ||
                          intraCityData.in_business_time != 1
                          ? 'no-achieve-intra-box'
                          : '')
                      }
                    >
                      <div>
                        <span
                          className="settlement-type-title"
                          style={convertLineStyleData('color:' + storeStyle.theme)}
                        >
                          <span className="ico-moon icon-goods-city-model"></span>
                          同城配送
                        </span>
                        <span className="settlement-type-express">
                          {'配送费' + intraCityData.express_fee + '元'}
                        </span>
                      </div>
                      <div className="settlement-type-count">
                        {'共' +
                          canUsePickUpType[2].goods_num +
                          '件，合计：￥' +
                          canUsePickUpType[2].goods_price}
                      </div>
                      {intraCityData.in_business_time != 1 ? (
                        <div
                          className="no-achieve-intra"
                          style={convertLineStyleData('color:' + storeStyle.theme)}
                        >
                          店铺已打烊
                        </div>
                      ) : intraCityData.is_enough_price != 1 ? (
                        <div
                          className="no-achieve-intra"
                          style={convertLineStyleData('color:' + storeStyle.theme)}
                        >
                          {'未达到起送价 还差' +
                            intraCityData.min_deliver_price_balance +
                            '元'}
                        </div>
                      ) : (
                            intraCityData.in_distance != 1 && (
                              <div
                                className="no-achieve-intra"
                                style={convertLineStyleData('color:' + storeStyle.theme)}
                              >
                                不在配送范围
                          </div>
                            )
                          )}
                    </div>
                    <div className="settlement-btn-box">
                      <div
                        data-type="2"
                        data-cart-id={canUsePickUpType[3].cart_list}
                        className={`settlement-btn ${intraCityData.is_enough_price != 1 || intraCityData.in_distance != 1 || intraCityData.in_business_time != 1 ? 'no-achieve-intra-btn' : ''}`}
                        style={{color: storeStyle.theme, borderColor: storeStyle.theme}}
                        onClick={intraCityData.is_enough_price != 1 || intraCityData.in_distance != 1 || intraCityData.in_business_time != 1 ? null : this.goodsPay}>选择</div>
                      {intraCityData.in_business_time == 1 &&
                        intraCityData.is_enough_price == 1 &&
                        intraCityData.in_distance != 1 && (
                          <div
                            className="settlement-btn"
                            style={convertLineStyleData(
                              'margin-left: 20rpx;color:' +
                              storeStyle.theme +
                              ';border-color:' +
                              storeStyle.theme
                            )}
                            onClick={this.selectGoodsSameJourney}
                          >
                            修改地址
                          </div>
                        )}
                    </div>
                  </div>
                )}
                {!!(canUsePickUpType[4] && canUsePickUpType[4].cart_list.length) && (
                  <div className="settlement-type">
                    <div
                      className={
                        'settlement-type-content ' +
                        (diningData.in_business_time != 1
                          ? 'no-achieve-intra-box'
                          : '')
                      }
                    >
                      <div>
                        <span
                          className="settlement-type-title"
                          style={convertLineStyleData('color:' + storeStyle.theme)}
                        >
                          <span className="ico-moon icon-goods-store-model"></span>
                          堂食点餐
                        </span>
                        {diningData.in_business_time != 1 && (
                          <span className="store-snoring">商家已打烊</span>
                        )}
                      </div>
                      <div className="settlement-type-count">
                        {'共' +
                          canUsePickUpType[4].goods_num +
                          '件，合计：¥' +
                          canUsePickUpType[4].goods_price}
                      </div>
                    </div>
                    <div className="settlement-btn-box">
                      <div
                        data-type="4"
                        data-cart-id={canUsePickUpType[4].cart_list}
                        className={
                          'settlement-btn ' +
                          (diningData.in_business_time != 1
                            ? 'no-achieve-intra-btn'
                            : '')
                        }
                        style={convertLineStyleData(
                          'color:' +
                          storeStyle.theme +
                          ';border-color:' +
                          storeStyle.theme
                        )}
                        onClick={
                          diningData.in_business_time != 1 ? null : this.goodsPay
                        }
                      >
                        选择
                      </div>
                    </div>
                  </div>
                  )}
              </div>
              <div
                className="close-settlement-mask"
                onClick={this.closeSettlement}
              >
                关闭
              </div>
            </div>
          )}
        </div>
        <GoodsShoppingCart ref={this.goodsShoppingCartRef} />
      </React.Fragment>
    )
  }
}




// WEBPACK FOOTER //
// ./src/official-page/shopping-cart/ShoppingCart.jsx